import { RegisteredComponent } from "@builder.io/sdk-react";

import { LiveChatComponent } from "@/components/LiveChat";

export const liveChatComponents: RegisteredComponent[] = [LiveChatComponent];
